import { useSelector } from "react-redux";
import { states, states_tr, states_nb } from "../../const/states";
import SortingButton from "../../../../components/Buttons/SortingButton";
import InputBox from "../../../../components/InputBox/InputBox";
import useSelectBrand from "#hooks/styles/useSelectBrand";
import useSkipFirstRender from "../../hooks/useSkipFirstRender";

//지역 선택
const SelectState = ({ states, selectArea, areaCode, color }) => {
  const handleChange = (e) => {
    selectArea(e.target.value);
  };

  return (
    <select
      className={`w-full font-medium bg-white select border-${color}`}
      onChange={handleChange}
      value={areaCode}
    >
      {states.map((item, index) => (
        <option key={index} defaultValue={index === 0} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  );
};

//대리점 선택
const SelectBranch = ({ branchList, selectBranch, storeId, color }) => {
  const handleChange = (e) => {
    selectBranch(e.target.value);
  };

  useSkipFirstRender(() => {
    selectBranch(branchList[0]?.id)
  }, [branchList.length]);

  return (
    <select
      className={`w-full font-medium bg-white select border-${color}`}
      onChange={handleChange}
      value={storeId}
    >
      {branchList.map((item, index) => (
        <option key={index} value={item.id}>
          {item.name}
        </option>
      ))}
    </select>
  );
};

// 상품 검색 결과  >  정렬버튼
const Sorting = ({ sortType, setSortType, loaded }) => {
  const handleOnClick = (label) => {
    if (sortType !== label) {
      setSortType(label);
    }
  };
  return (
    <>
      {loaded === true ? (
        <div className="flex justify-end items-start gap-0.5 my-3.5 ">
          <SortingButton
            value="recommend"
            label="추천순"
            isActive={sortType === "recommend"}
            onClick={() => handleOnClick("recommend")}
          />
          <SortingButton
            value="sell"
            label="판매순"
            isActive={sortType === "sale"}
            onClick={() => handleOnClick("sale")}
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

const SearchInput = ({
  selectArea,
  handleInputChange,
  handleClearClick,
  search,
  branchList,
  selectBranch,
  keyword,
  sortType,
  setSortType,
  areaCode,
  storeId,
  loaded,
}) => {
  const { color } = useSelectBrand();
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  return (
    <>
      <div className="sticky flex flex-col gap-2 py-2 bg-white top-[4.5rem] z-50">
        <div className="flex gap-2">
          <SelectState
            states={brandId === 'TR' ? states_tr : brandId === 'NB' ? states_nb : states}
            selectArea={selectArea}
            areaCode={areaCode}
            branchList={branchList}
            color={color}
          />
          {branchList?.length > 0 ? (
            <SelectBranch
              branchList={branchList}
              selectBranch={selectBranch}
              storeId={storeId}
              color={color}
            />
          ) : (
            <div className="flex items-center w-full rounded-lg bg-neutral-100 text-neutral-400 select">
              점포없음
            </div>
          )}
        </div>
        <InputBox
          keyword={keyword}
          handleInputChange={handleInputChange}
          handleClearClick={handleClearClick}
          search={search}
          placeholder="찾으시는 상품을 검색해 주세요"
          color={color}
        />
      </div>
      {keyword && (
        <Sorting
          sortType={sortType}
          setSortType={setSortType}
          loaded={loaded}
        />
      )}
    </>
  );
};

export default SearchInput;
